import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AdminImportRequestItemShow } from './useFetchAdminImportRequestItemShow';

export type UpdateAdminImportRequestItemOuterJobPostParams = {
  title?: string;
  company_name?: string;
  job_content?: Array<{ key?: string; label?: string; content?: string }>;
  agent_content?: Array<{ key?: string; label?: string; content?: string }>;
};

type UpdateAdminImportRequestItemParams = {
  importRequestId: number;
  itemId: number;
  outer_job_post: UpdateAdminImportRequestItemOuterJobPostParams;
};

export default function useUpdateAdminImportRequestItem() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: UpdateAdminImportRequestItemParams) => {
      const response = await fetch(
        `/admin/api/import_requests/${params.importRequestId}/items/${params.itemId}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token || '',
          },
          body: JSON.stringify({ outer_job_post: params.outer_job_post }),
        }
      );
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        const err = body as { error?: string; message?: string };
        throw new Error(err.error ?? err.message ?? 'インポートリクエスト項目の更新に失敗しました');
      }
      return (await response.json()) as AdminImportRequestItemShow;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['admin', 'import_requests', variables.importRequestId, 'items'],
      });
      queryClient.invalidateQueries({
        queryKey: [
          'admin',
          'import_requests',
          variables.importRequestId,
          'items',
          variables.itemId,
        ],
      });
    },
  });
}
